import { render, staticRenderFns } from "./KeepUpWorkBoostIntegration.vue?vue&type=template&id=b3a00c4e&scoped=true&"
import script from "./KeepUpWorkBoostIntegration.vue?vue&type=script&lang=js&"
export * from "./KeepUpWorkBoostIntegration.vue?vue&type=script&lang=js&"
import style0 from "./KeepUpWorkBoostIntegration.vue?vue&type=style&index=0&id=b3a00c4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a00c4e",
  null
  
)

export default component.exports